// extracted by mini-css-extract-plugin
module.exports = {"container":"Game_container__1n8Dh","game_title":"Game_game_title__3G5xf","transition_container":"Game_transition_container__3ozru","no_mobile":"Game_no_mobile__2ach3"};